







































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { activityGroupFields } from '@/config/activities';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import moment from 'moment';
import CustomFilepond from '@shared/components/forms/inputs/filepond/custom-filepond.vue';
import Colorpicker from '@shared/components/forms/inputs/colorpicker/colorpicker.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import Time from '@shared/components/forms/inputs/time/time.vue';
import { ActivityGroup } from '@activities/interfaces/activity-group';
import DayTimeRepeater from '@shared/components/forms/inputs/day-time-repeater/day-time-repeater.vue';
import { setProp } from '@shared/helpers/operators';

@Component({
  name: 'bpc-activity-formula-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
    'bpc-filepond': CustomFilepond,
    'bpc-colorpicker': Colorpicker,
    'bpc-multi-select': MultiSelect,
    'bpc-time': Time,
    'bpc-day-time-repeater': DayTimeRepeater,
  },
})
export default class ActivityFormulaForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: ActivityGroup;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideEnrollmentSettings: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: ActivityGroup;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly actionButtonsPortalTarget: string;
  // DATA
  formModel: ActivityGroup = null;

  // COMPUTED
  get activityGroupId(): string | number {
    return this.formModel?.id || this.modelId || null;
  }

  get fieldsConfig() {
    return activityGroupFields;
  }

  // LIFECYCLE
  // created(){}
  // mounted() {}
  // updated(){}
  // destroyed(){}

  // METHODS
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded() {
    this.$emit('model-loaded', this.formModel);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  onSaveActivityFormula(formModel) {
    const model = this.prepareToSave(formModel);
    this.$refs.formProvider.saveEntity(model);
  }

  prepareToSave(formModel): Function {
    const model = JSON.parse(JSON.stringify(formModel));
    if (formModel) {
      const contactIds = formModel.contacts.map(contact => {
        return contact.id;
      });
      setProp(model, 'contacts', contactIds);
    }
    return model;
  }

  // WATCHERS
}
